import { useQuery } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { DefaultFetchService } from "app/services/fetchService";

const API_PATH = "/api/aiTracker/classify-brands";

interface IDetectedBrandsResponse {
    brands: string[];
}

const detectedBrandsQueryKey = (domain: string) => ["llm-tracker", "detect brands", domain];

export const useDetectedBrands = (domain: string, options?: { enabled?: boolean }) =>
    useQuery<string[]>({
        queryKey: detectedBrandsQueryKey(domain),
        queryFn: async () => {
            try {
                const fetchService = DefaultFetchService.getInstance();
                const response = await fetchService.post<IDetectedBrandsResponse>(API_PATH, {
                    domain
                });

                return response?.brands ?? [];
            } catch (error) {
                Sentry.errorTracker({
                    e: error,
                    message: "Error detecting brands from AI Tracker API",
                    params: {
                        extra: {
                            domain
                        },
                    },
                });

                return [];
            }
        },
        ...options,
    });
